import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { AppConfig, RestHttp } from "@lantern/app/core";

@Injectable()
export class RecaptchaApi {
  private basePath = `${this.app.apiPath}/recaptcha`;
  constructor(
    private rest: RestHttp,
    private app: AppConfig
  ) {}

  getSiteKey(): Observable<string> {
    return this.rest.get(
      `${this.basePath}/site-key`,
      undefined,
      "text"
    );
  }
}
